import { connectBaseApi, createRpcMutation, createRpcQuery, authClient } from "@racoon/api";
import { AUTH_STORAGE } from "@racoon/lib";

export { AUTH_STORAGE };

const authApi = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getMe: createRpcQuery(build, authClient, "me", {
      providesTags: ["Employee"],
    }),
    login: createRpcMutation(build, authClient, "login", {
      invalidatesTags: ["Employee"],
      async onQueryStarted(_args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          localStorage.setItem(AUTH_STORAGE.token, data.accessToken);
          localStorage.setItem(AUTH_STORAGE.tokenType, data.tokenType || "Bearer");
          localStorage.setItem(AUTH_STORAGE.user, JSON.stringify(data.me));
          if (data.refreshToken) {
            localStorage.setItem(AUTH_STORAGE.refresh, data.refreshToken);
          } else {
            localStorage.removeItem(AUTH_STORAGE.refresh);
          }
        } catch {
          // Error handled by RTK Query
        }
      },
    }),
    sendOtp: createRpcMutation(build, authClient, "requestOTP", {}),
    loginOtp: createRpcMutation(build, authClient, "loginOTP", {
      async onQueryStarted(_args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          localStorage.setItem(AUTH_STORAGE.token, data.accessToken);
          localStorage.setItem(AUTH_STORAGE.tokenType, data.tokenType || "Bearer");
          localStorage.setItem(AUTH_STORAGE.user, JSON.stringify(data.me));
          if (data.refreshToken) {
            localStorage.setItem(AUTH_STORAGE.refresh, data.refreshToken);
          } else {
            localStorage.removeItem(AUTH_STORAGE.refresh);
          }
        } catch {
          // Error handled by RTK Query
        }
      },
    }),
    resetPassword: createRpcMutation(build, authClient, "resetPassword", {}),
    refreshToken: createRpcMutation(build, authClient, "refreshToken", {}),
  }),
  overrideExisting: false,
});

export const {
  useGetMeQuery,
  useLoginMutation,
  useSendOtpMutation,
  useLoginOtpMutation,
  useResetPasswordMutation,
} = authApi;
